export default {"src":"/_next/static/media/compassion.48e13117.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};